import { render, staticRenderFns } from "./video-widget.vue?vue&type=template&id=ae86dd6c&scoped=true&"
import script from "./video-widget.vue?vue&type=script&lang=js&"
export * from "./video-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae86dd6c",
  null
  
)

export default component.exports